export class PlayerStats {
  wagered: number;
  profit: number;
  losses: number;
  wins: number;

  constructor() {
    this.wagered = 0;
    this.profit = 0;
    this.losses = 0;
    this.wins = 0;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/models/player-stats.model.ts